import {Directive, Output, OnInit, EventEmitter, ElementRef, NgZone, HostListener} from '@angular/core';

@Directive({
    selector: '[apenasnumero]',
})
export class ApenasNumeroDirective {
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter(false);

    constructor(
    private _el: ElementRef,
    private _ngZone: NgZone) { }

    @HostListener('keyup') onKeyUp() {
        if(this._el.nativeElement.value)
        {        
            var newValue = this._el.nativeElement.value.replace(/[A-Za-z\/\/]/g, '');

            this._ngZone.run(() =>
                this.ngModelChange.emit(newValue));
        }
    }
    
    ngOnInit() {

    }
}




/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/directives/apenasnumero.directive.ts
 **/